<template>
  <div class="login">
    <div v-if="userInfo" class="login-container">
      <div class="login-container-bg">
        <div class="login-container-bg1">
          <div class="mt-25 font-16 tip-title">- 学校名称 -</div>
          <div class="font-18 tip">
            {{ userInfo.collegeName }}
          </div>
          <div class="mt-25 font-16 tip-title">- 考试名称 -</div>
          <div class="font-18 tip">
            {{ userInfo.batchName }}
          </div>
          <div class="mt-25 font-16 tip-title">暂无考场，请稍候...</div>
          <div class="mt-20">
            <!-- <i class="el-icon-loading mt-20" style="font-size: 40px;"></i> -->
            <div class="spinner">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
          <el-button style="width:100%;height:45px;font-size:18px;margin-top:25px;" type="primary" @click="$router.back()">返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      taskTimer: null,
      userInfo: null,
    }
  },
  created() {
    this.userInfo = this.$utils.$localStorage.get('userInfo')
    this.getCurrentTask()
  },
  methods: {
    async getCurrentTask() {
      const _this = this
      this.clearTimerHeart()
      const res1 = await this.$HTTP.ApiLogin.POSTroomForInspectCode({
        monitorCode: this.userInfo.monitorCode,
        prevRoomId: '',
      })
      if (res1) {
        const user = {
          ...this.userInfo,
          roomId: res1.roomId,
          roomName: res1.roomName,
          ...res1.liveRound,
        }
        this.$utils.$localStorage.set('subjectList', res1.subjectList || [])
        this.$utils.$localStorage.set('userInfo', user)
        this.$router.push('/live-code')
        return
      }
      const taskTimer = setInterval(async () => {
        const res = await this.$HTTP.ApiLogin.POSTroomForInspectCode({
          monitorCode: this.userInfo.monitorCode,
          prevRoomId: '',
        })
        if (res) {
          const user = {
            ...this.userInfo,
            roomId: res.roomId,
            roomName: res.roomName,
            ...res.liveRound,
          }
          this.$utils.$localStorage.set('subjectList', res.subjectList || [])
          this.$utils.$localStorage.set('userInfo', user)
          this.$router.push('/live-code')
        }
      }, 3000)
      this.taskTimer = taskTimer
      this.$once('hook:beforeDestroy', () => {
        // 销毁页面后取消订阅，避免多次订阅
        _this.clearTimerHeart()
      })
      this.$once('hook:destroyed', () => {
        // 销毁页面后取消订阅，避免多次订阅
        _this.clearTimerHeart()
      })
    },
    clearTimerHeart() {
      if (this.taskTimer) {
        clearInterval(this.taskTimer)
        this.taskTimer = null
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  min-width: 440px;
  display: flex;
  justify-content: center;
  align-items: center;
  &-container {
    width: 440px;
    height: 440px;
    border: 2px solid rgba(112, 112, 112, 0.6);
    border-radius: 16px;
    background-color: rgba(37, 43, 77, 1);
    box-shadow: 0px 14px 32px rgba(0, 8, 29, 0.16);
    &-bg1 {
      width: 100%;
      height: 100%;
      background: url("../../assets/img_logo.png") no-repeat bottom right;
      background-size: 60%;
      padding: 30px 50px;
      color: #fff;
      text-align: center;
    }
    &-bg {
      width: 100%;
      height: 100%;
      background: url("../../assets/img_in.png") no-repeat left top;
      background-size: 100%;
    }
    .tip-title {
      font-family: PingFang SC;
      color: rgba(255, 255, 255, 0.65);
      line-height: 28px;
    }
    .tip {
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 28px;
    }
    // loading-----start
    .spinner {
      margin: 0 auto;
      width: 50px;
      height: 45px;
      text-align: center;
      font-size: 10px;
    }
    .spinner > div {
      background-color: #fff;
      height: 100%;
      width: 5px;
      margin-right: 3px;
      display: inline-block;
      -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
      animation: sk-stretchdelay 1.2s infinite ease-in-out;
    }
    .spinner .rect2 {
      -webkit-animation-delay: -1.1s;
      animation-delay: -1.1s;
    }
    .spinner .rect3 {
      -webkit-animation-delay: -1.0s;
      animation-delay: -1.0s;
    }
    .spinner .rect4 {
      -webkit-animation-delay: -0.9s;
      animation-delay: -0.9s;
    }
    .spinner .rect5 {
      -webkit-animation-delay: -0.8s;
      animation-delay: -0.8s;
    }
    @-webkit-keyframes sk-stretchdelay {
      0%, 40%, 100% { -webkit-transform: scaleY(0.4) }
      20% { -webkit-transform: scaleY(1.0) }
    }
    @keyframes sk-stretchdelay {
      0%, 40%, 100% {
        transform: scaleY(0.4);
        -webkit-transform: scaleY(0.4);
      }  20% {
        transform: scaleY(1.0);
        -webkit-transform: scaleY(1.0);
      }
    }
    // loading-----end
  }
}
</style>
